/* eslint-disable no-useless-escape */
import * as yup from "yup";

const LoginSchema = yup.object({
  email: yup
    .string()
    .trim()
    .required("Vui lòng nhập email")
    .email("Vui lòng nhập đúng định dạng email")
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Vui lòng nhập đúng định dạng email"
    ),
  password: yup.string().trim().required("Vui lòng nhập mật khẩu"),
  captchaToken: yup.string().trim().required("Bạn là robot"),
});

const OtpSchema = yup.object({
  otpCode: yup.string().trim().required("msg_error_input_require"),
});

export { LoginSchema, OtpSchema };
